// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Administration Page - Rich Text Content Styles */

.administration-header-content p,
.director-office-content p,
.team-responsibilities-content p {
  margin-bottom: 0.75rem;
  line-height: 1.6;
}

.administration-header-content strong,
.director-office-content strong,
.team-responsibilities-content strong {
  font-weight: 700;
  color: #1e293b;
}

.administration-header-content em,
.director-office-content em,
.team-responsibilities-content em {
  font-style: italic;
}

.administration-header-content ul,
.director-office-content ul,
.team-responsibilities-content ul {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}

.administration-header-content ol,
.director-office-content ol,
.team-responsibilities-content ol {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}

.administration-header-content li,
.director-office-content li,
.team-responsibilities-content li {
  margin-bottom: 0.25rem;
  line-height: 1.5;
}

.administration-header-content h1,
.director-office-content h1,
.team-responsibilities-content h1 {
  font-size: 1.875rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #1e293b;
}

.administration-header-content h2,
.director-office-content h2,
.team-responsibilities-content h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  color: #1e293b;
}

.administration-header-content h3,
.director-office-content h3,
.team-responsibilities-content h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1e293b;
}

.administration-header-content a,
.director-office-content a,
.team-responsibilities-content a {
  color: #9b1c31;
  text-decoration: underline;
}

.administration-header-content a:hover,
.director-office-content a:hover,
.team-responsibilities-content a:hover {
  color: #7a1628;
}

.administration-header-content blockquote,
.director-office-content blockquote,
.team-responsibilities-content blockquote {
  border-left: 4px solid #9b1c31;
  padding-left: 1rem;
  margin: 1rem 0;
  font-style: italic;
  color: #64748b;
}

/* Quill editor specific classes */
.administration-header-content .ql-align-center,
.director-office-content .ql-align-center,
.team-responsibilities-content .ql-align-center {
  text-align: center;
}

.administration-header-content .ql-align-right,
.director-office-content .ql-align-right,
.team-responsibilities-content .ql-align-right {
  text-align: right;
}

.administration-header-content .ql-align-justify,
.director-office-content .ql-align-justify,
.team-responsibilities-content .ql-align-justify {
  text-align: justify;
}

.administration-header-content .ql-size-small,
.director-office-content .ql-size-small,
.team-responsibilities-content .ql-size-small {
  font-size: 0.875rem;
}

.administration-header-content .ql-size-large,
.director-office-content .ql-size-large,
.team-responsibilities-content .ql-size-large {
  font-size: 1.25rem;
}

.administration-header-content .ql-size-huge,
.director-office-content .ql-size-huge,
.team-responsibilities-content .ql-size-huge {
  font-size: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdministrationPage.css"],"names":[],"mappings":"AAAA,mDAAmD;;AAEnD;;;EAGE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;AACnB","sourcesContent":["/* Administration Page - Rich Text Content Styles */\n\n.administration-header-content p,\n.director-office-content p,\n.team-responsibilities-content p {\n  margin-bottom: 0.75rem;\n  line-height: 1.6;\n}\n\n.administration-header-content strong,\n.director-office-content strong,\n.team-responsibilities-content strong {\n  font-weight: 700;\n  color: #1e293b;\n}\n\n.administration-header-content em,\n.director-office-content em,\n.team-responsibilities-content em {\n  font-style: italic;\n}\n\n.administration-header-content ul,\n.director-office-content ul,\n.team-responsibilities-content ul {\n  list-style-type: disc;\n  padding-left: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.administration-header-content ol,\n.director-office-content ol,\n.team-responsibilities-content ol {\n  list-style-type: decimal;\n  padding-left: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.administration-header-content li,\n.director-office-content li,\n.team-responsibilities-content li {\n  margin-bottom: 0.25rem;\n  line-height: 1.5;\n}\n\n.administration-header-content h1,\n.director-office-content h1,\n.team-responsibilities-content h1 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  color: #1e293b;\n}\n\n.administration-header-content h2,\n.director-office-content h2,\n.team-responsibilities-content h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.75rem;\n  color: #1e293b;\n}\n\n.administration-header-content h3,\n.director-office-content h3,\n.team-responsibilities-content h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #1e293b;\n}\n\n.administration-header-content a,\n.director-office-content a,\n.team-responsibilities-content a {\n  color: #9b1c31;\n  text-decoration: underline;\n}\n\n.administration-header-content a:hover,\n.director-office-content a:hover,\n.team-responsibilities-content a:hover {\n  color: #7a1628;\n}\n\n.administration-header-content blockquote,\n.director-office-content blockquote,\n.team-responsibilities-content blockquote {\n  border-left: 4px solid #9b1c31;\n  padding-left: 1rem;\n  margin: 1rem 0;\n  font-style: italic;\n  color: #64748b;\n}\n\n/* Quill editor specific classes */\n.administration-header-content .ql-align-center,\n.director-office-content .ql-align-center,\n.team-responsibilities-content .ql-align-center {\n  text-align: center;\n}\n\n.administration-header-content .ql-align-right,\n.director-office-content .ql-align-right,\n.team-responsibilities-content .ql-align-right {\n  text-align: right;\n}\n\n.administration-header-content .ql-align-justify,\n.director-office-content .ql-align-justify,\n.team-responsibilities-content .ql-align-justify {\n  text-align: justify;\n}\n\n.administration-header-content .ql-size-small,\n.director-office-content .ql-size-small,\n.team-responsibilities-content .ql-size-small {\n  font-size: 0.875rem;\n}\n\n.administration-header-content .ql-size-large,\n.director-office-content .ql-size-large,\n.team-responsibilities-content .ql-size-large {\n  font-size: 1.25rem;\n}\n\n.administration-header-content .ql-size-huge,\n.director-office-content .ql-size-huge,\n.team-responsibilities-content .ql-size-huge {\n  font-size: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
